import React from 'react';
import PropTypes from 'prop-types';

import { UI_LANDING_STYLE_PREFIX } from '../../../constants/appConstants';

const { Button } = require('@andes/button');

const className = `${UI_LANDING_STYLE_PREFIX}-offer-button-component`;

const OfferButton = (props) => {
  const { value, melidata } = props;

  const sendTrack = () => {
    const data = {
      ...melidata,
      path: '/landing_catalog/offers', // TODO define in backend
      type: 'event',
    };

    window.melidata('cleanAndSend', 'event', data);
  };

  return (
    <div className={`${className}__buttons-container`}>
      <a href={value.url}>
        <Button
          className={`${className}__button`}
          size="large"
          onClick={sendTrack}
        >
          {value.text}
        </Button>
      </a>
    </div>
  );
};

OfferButton.propTypes = {
  value: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  melidata: PropTypes.shape({
    user_type: PropTypes.string,
    logged: PropTypes.bool,
    business_unit: PropTypes.string.isRequired,
    page_type: PropTypes.string.isRequired,
    brand: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
};

export default OfferButton;
